import { put, call, takeLatest } from "redux-saga/effects";
import * as Actions from "us.collection.input-output/actions";
import * as API from "us.collection.input-output/services";
import { DocumentsManagerHistory } from "us.collection.input-output/constants/Actions";
import { $MessageBox } from "us.common/components";
const { documentsManagerHistory } = Actions;

const DocumentsManagerHistorySagas = {
  assignedDocuments: {
    get: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const { data, status } = yield call(
          API.documentsManagerHistory.assignedDocuments.get,
          params,
        );

        if (status == 200 || status == 204) {
          yield put(documentsManagerHistory.assignedDocuments.success(data));
        } else {
          $MessageBox(
            "error",
            `US.COLLECTION.INPUT-OUTPUT:DOCUMENTS_MANAGER_HISTORY.FAILED_TO_LOAD_HISTORY`,
            "",
            "",
          );
          yield put(
            documentsManagerHistory.assignedDocuments.fail(new Error()),
          );
        }
      } catch (error) {
        $MessageBox(
          "error",
          "US.COLLECTION.INPUT-OUTPUT:DOCUMENTS_MANAGER_HISTORY.FAILED_TO_LOAD_HISTORY",
          "",
          "",
        );
        yield put(documentsManagerHistory.assignedDocuments.fail(new Error()));
      }
    },
    delete: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const { status } = yield call(
          API.documentsManagerHistory.assignedDocuments.delete,
          params,
        );

        if (status == 200) {
          if (documentsManagerHistory.assignedDocuments.deleteSuccess) {
            yield put(
              documentsManagerHistory.assignedDocuments.deleteSuccess(params),
            );
          }
        } else {
          if (documentsManagerHistory.assignedDocuments.deleteFail) {
            yield put(
              documentsManagerHistory.assignedDocuments.deleteFail(new Error()),
            );
          }
        }
      } catch (error) {
        if (documentsManagerHistory.assignedDocuments.deleteFail) {
          yield put(
            documentsManagerHistory.assignedDocuments.deleteFail(new Error()),
          );
        }
      }
    },
  },

  documentContent: {
    get: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const data = yield call(
          API.documentsManagerHistory.documentContent.get,
          params,
        );
        if (data?.code == 400 || data?.code == 404 || data?.errors) {
          yield put(documentsManagerHistory.documentContent.fail(data));
        } else {
          yield put(documentsManagerHistory.documentContent.success(data));
        }
      } catch (error: any) {
        yield put(documentsManagerHistory.documentContent.fail(error));
      }
    },
  },
};

export default [
  takeLatest(
    DocumentsManagerHistory.GET_ASSIGNED_DOCUMENTS_HISTORY,
    DocumentsManagerHistorySagas.assignedDocuments.get,
  ),
  takeLatest(
    DocumentsManagerHistory.DELETE_ASSIGNED_DOCUMENTS,
    DocumentsManagerHistorySagas.assignedDocuments.delete,
  ),
  takeLatest(
    DocumentsManagerHistory.GET_ASSIGNED_DOCUMENT_CONTENT,
    DocumentsManagerHistorySagas.documentContent.get,
  ),
];
